import Model, { attr, hasMany, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class AirbnbOfficialOpportunityModel extends Model {
  @attr('array') applicableListingIds!: string[];
  @attr('string') description!: string;
  @attr('number') hostCompletionPercentage!: number;
  @attr('string') title!: string;
  @attr('string') type!: string;

  @belongsTo('channel-notification', {
    inverse: 'airbnbOfficialOpportunities',
    async: false,
  })
  channelNotification!: ModelRegistry['channel-notification'];

  @belongsTo('airbnb-official-connection', {
    inverse: null,
    async: false,
  })
  airbnbOfficialConnection!: ModelRegistry['airbnb-official-connection'];

  @hasMany('airbnb-official-opportunity-input-field', {
    inverse: null,
    async: false,
  })
  airbnbOfficialOpportunityInputFields!: ModelRegistry['airbnb-official-opportunity-input-field'][];

  @hasMany('airbnb-official-listing', {
    inverse: null,
    async: false,
  })
  airbnbOfficialListings!: ModelRegistry['airbnb-official-listing'][];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'airbnb-official-opportunity': AirbnbOfficialOpportunityModel;
  }
}
